/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { SelectedToken } from "../../../components/TradeLeg/sections/elements/SelectedToken";
import { Token } from "../../../store/global/TokenEnum";
import "../../Trade/index.css";

export interface TokenSectionProps {
  symbol: Token | undefined;
  tokenIcon: string;
  counterParty: "maker" | "taker";
}

export const TokenSection: React.FC<TokenSectionProps> = ({ symbol, tokenIcon }) => {
  const renderLabel = () => {
    if (symbol)
      return (
        <>
          <img width="32" height="32" src={tokenIcon} alt={symbol} />
          <SelectedToken>{symbol}</SelectedToken>
        </>
      );
  };

  return (
    <div
      className={`symbol`}
      css={css`
        min-width: 141px;
      `}
    >
      <span className="d-flex align-items-center">{renderLabel()}</span>
    </div>
  );
};
